<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Dr3TqA/tc-custom/9781504026567.jpg?1728851686418" alt="This image is the cover for the book Newton's Cannon, The Age of Unreason"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Newton's Cannon, The Age of Unreason
      </h1>
      <p class="bookDescription body article font2">
        <b>This novel of Ben Franklin, Isaac Newton, and a demonic Louis XIV is “eminently worthwhile reading for both fantasy and alternate-history lovers” (<i>Booklist</i>).</b><br/><br/><i>In 1681, in an England somewhat like our England . . . </i>the great alchemist Sir Isaac Newton makes the remarkable discovery of a substance he calls philosopher’s mercury, with which one can manipulate the four essential elements of the universe: earth, water, air, and fire.<br/>  <br/> In the opulent court of Britain’s greatest enemy, the ancient King Louis XIV, his life alchemically and indefinitely prolonged, employs treacherous means to obtain the prize that will grant him dominion over the entire continent. Meanwhile, his brilliant and beautiful mistress, Adrienne de Mornay de Montchevreuil, secretly pursues a mathematical method to prevent his takeover.<br/>  <br/> And in another corner of the world, the young printer’s apprentice and aspiring alchemist Ben Franklin is plagued by a demon and flees to England seeking the aid of his hero: Newton. But Franklin will discover that Newton has demons of his own . . .<br/>  <br/> A wondrously dark and richly imagined alternate history, Greg Keyes’s <i>Newton’s Cannon </i>is the first book in his extraordinary Age of Unreason series—a magnificent journey to a past that never was in a world where magic is a science and the greatest minds must conspire to prevent an end to all things.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Greg Keyes
      </h2>
      
      <p class="authorDescription body article">Greg Keyes was born in 1963 in Meridian, Mississippi. When his father took a job on the Navajo reservation in Arizona, Keyes was exposed at an early age to the cultures and stories of the Native Southwest, which would continue to influence him for years to come.&#160;He earned a bachelor&rsquo;s degree in anthropology from Mississippi State University and a master&rsquo;s degree from the University of Georgia. While pursuing a PhD at UGA, he wrote several novels, including <I>The Waterborn</I> and its sequel,&#160;<I>The Blackgod</I>.&#160;He followed these with&#160;the Age of Unreason books, the epic fantasy series Kingdoms of Thorn and Bone, and tie-in novels for numerous franchises, including Star Wars, Babylon 5, the Elder Scrolls, and Planet of the Apes. Keyes lives and works in Savannah, Georgia, with his wife, Nell; son, Archer; and daughter, Nellah.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5866def7